/* global axios */

import ApiClient from './ApiClient';

class LifecycleStagesAPI extends ApiClient {
  constructor() {
    super('lifecycle_stages', { accountScoped: true });
  }

  updateSettings(data) {
    return axios.patch(`${this.url}/settings`, data);
  }
}

export default new LifecycleStagesAPI();
